export default {"src":"/_next/static/media/hyper-local-targeting.51b27275.svg","height":142,"width":142,"blurWidth":0,"blurHeight":0};